import React from 'react';
import { bool, func } from 'prop-types';
import styled from 'styled-components';

const StyledHamburger = styled.div`
  display: none;
  width: 64px;
  height: 64px;
  position: relative;
  font: inherit;
  overflow: visible;
  margin: 0;
  padding: 15px;
  cursor: pointer;
  transition-timing-function: linear;
  transition-duration: .15s;
  transition-property: opacity,filter;
  text-transform: none;
  color: inherit;
  border: 0;
  background-color: #fff;

  @media(max-width: 1024px) {
    display: block;
  }
`;
const HamburgerBox = styled.div`
  background: currentColor;
  width: 35px;
  height: ${props=>props.open?'7px':'4px'};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,${props=>props.open?'-.5em':'-50%'}) rotate(${props=>props.open?'45':'0'}deg) scale(${props=>props.open?'0.75':1});
  transition: all .125s ease-in-out;
  border-radius: 5px;
  will-change: transform, height;

  :before {
    content: "";
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    background: currentColor;
    border-radius: 5px;
    transition: transform .125s ease-in-out;
    transform: translateY(${props=>props.open?'0':'-10'}px) rotate(${props=>props.open?'90':'0'}deg);
  }

  :after {
    content: "";
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    background: currentColor;
    border-radius: 5px;
    transition: transform .125s ease-in-out;
    transform: translateY(${props=>props.open?'0':'10'}px) rotate(${props=>props.open?'-90':'0'}deg);
  }
`;

const HamburgerText = styled.div`
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
  left: 0;
  opacity: ${props=>props.open?'1':'0'};
  transform: translateY(${props=>props.open?'0':'.5em'});
  transition: all .125s ease-in-out;
`;

const Hamburger = ({ onClick, isOpen }) => (
  <StyledHamburger onClick={onClick}>
    <HamburgerBox open={isOpen} />
    <HamburgerText open={isOpen}>
      close
    </HamburgerText>
  </StyledHamburger>
);

Hamburger.propTypes = {
  onClick: func,
  isOpen: bool
};

export default Hamburger;